export const CARD_DESIGN_MYSELF_FORMAT = "ODC-ORG-086054-01";
export const CARD_DESIGN_REQUEST_FORMAT = "ODC-ORG-086054-02";
export const CARD_DESIGN_UPLOAD_FORMAT = "ODC-ORG-086054-99";

export function isCardDesignMyselfFormat(format_group_id: string):boolean{
    return format_group_id === CARD_DESIGN_MYSELF_FORMAT;
}

export function isCardDesignRequestFormat(format_group_id: string):boolean{
    return format_group_id === CARD_DESIGN_REQUEST_FORMAT;
}

export function isCardDesignUploadFormat(format_group_id: string):boolean{
    return format_group_id === CARD_DESIGN_UPLOAD_FORMAT;
}